import { render, staticRenderFns } from "./statuses.vue?vue&type=template&id=000fefd2&scoped=true&"
import script from "./statuses.vue?vue&type=script&lang=js&"
export * from "./statuses.vue?vue&type=script&lang=js&"
import style0 from "./statuses.vue?vue&type=style&index=0&id=000fefd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000fefd2",
  null
  
)

export default component.exports